import { isEqual } from 'lodash-es';
import { memo } from 'react';

import { TimeseriesChartDatapoints } from './TimeseriesChartDatapoints.js';
import { TimeseriesChartTooltip } from './TimeseriesChartTooltip.js';
import { GroupDataPoint } from '../../../../core/types/data-point.js';
import { useExploreState } from '../../../hooks/store/selectors.js';
import { useTimeseriesFilteredData } from '../../../hooks/useTimeseriesFilteredData.js';
import { TimeseriesClosestPoint } from '../utils/tooltip/find-closest-points.js';

type TimeseriesInspectProps = {
  filteredPoints: TimeseriesClosestPoint[];
  closestPoint: TimeseriesClosestPoint;
  groupedPoints: GroupDataPoint;
};

export const TimeseriesInspect = memo(
  ({ filteredPoints, closestPoint, groupedPoints }: TimeseriesInspectProps) => {
    const { data: series } = useTimeseriesFilteredData();
    const { pinned, visible } = useExploreState();

    const showDatapoints = visible || pinned;

    return (
      <>
        {showDatapoints && (
          <TimeseriesChartDatapoints
            closestPoint={pinned ? undefined : closestPoint}
            groupedPoints={groupedPoints}
          />
        )}
        {filteredPoints.length > 0 && (
          <TimeseriesChartTooltip
            series={series}
            closestPoint={closestPoint}
            xPoints={filteredPoints}
            groupedPoints={groupedPoints}
          />
        )}
      </>
    );
  },
  isEqual,
);

TimeseriesInspect['displayName'] = 'TimeseriesInspect';
